import React from 'react';
import { Dialog, DialogContent, Button, Grid, Typography } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';
import { Close } from '@mui/icons-material';
import GuardianImageSuccess from '../../../../assets/icon/Add_guardian_success.svg';
import './MinPromise.css';

const MinPromisePopup2 = ({ handleClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <DialogContent>
      <Grid container direction="column" alignItems="center">
        {/* Image */}
        <Grid item>
          <img
            src={GuardianImageSuccess}
            alt="Add Guardian"
            style={{
              width: isMobile ? '120px' : '200px',
              height: 'auto',
              marginBottom: '10px',
            }}
          />
        </Grid>

        {/* Title */}
        <Grid item style={{ marginTop: '20px', width: '100%' }}>
          <Typography
            variant="h3"
            align="left" // Align text to the left
            fontSize={isMobile ? '24px' : '30px'}
            fontWeight="800"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            Congratulations!
          </Typography>
        </Grid>

        {/* Description */}
        <Grid item style={{ marginTop: '20px', width: '100%' }}>
          <Typography
            variant="body1"
            align="left" // Align text to the left
            fontSize={isMobile ? '14px' : '18px'}
            fontWeight="700"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            You've Made the Best Decision as a Parent!
          </Typography>
        </Grid>

        <Grid item style={{ marginTop: '20px' }}>
          <Typography
            variant="body2"
            align="left" // Align text to the left
            fontSize={isMobile ? '12px' : '16px'}
            fontWeight="600"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            You’ve just taken an important step in your child’s future. The
            world is changing, and so is the way our children will need to
            learn. Rote memorization and traditional grading can't dominate
            learning anymore when machines can do that work better.
          </Typography>
        </Grid>

        <Grid item style={{ marginTop: '20px' }}>
          <Typography
            variant="body2"
            align="left" // Align text to the left
            fontSize={isMobile ? '12px' : '16px'}
            fontWeight="600"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            But what machines can’t replicate is the spirit, imagination,
            creativity, kindness, and love that make us human. By committing to
            the 20-Minute Promise, you’ve chosen to nurture these natural gifts
            in your child and join a new revolution in learning.
          </Typography>
        </Grid>

        <Grid item style={{ marginTop: '20px', width: '100%' }}>
          <Typography
            variant="body1"
            align="left" // Align text to the left
            fontSize={isMobile ? '14px' : '18px'}
            fontWeight="700"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            WELL DONE TO YOU!
          </Typography>
        </Grid>
      </Grid>

      {/* Button */}
      <Grid container direction="column" alignItems="center">
        <Grid item width="100%" sx={{ maxWidth: '392px !important' }}>
          <button
            className="Yes_btn"
            style={{
              marginTop: isMobile ? '16px' : '20px',
              fontSize: isMobile ? '14px' : '16px',
              width: '100%',
            }}
            onClick={handleClose}
          >
            Next
          </button>
        </Grid>
      </Grid>
    </DialogContent>
  );
};

export default MinPromisePopup2;
